import type { Ref } from 'react';

import { MIN_TILE_HEIGHT_IN_CELLS } from '@/config/grid.ts';
import type { GridCoordinates } from '@/types/grid.ts';

import './TileSkeleton.css';
import { gridToPx } from '@/utils/grid/coordinates.ts';

type TileSkeletonProps = {
  ref: Ref<HTMLDivElement>;
  span?: GridCoordinates;
  onClick?: () => void;
};

const DEFAULT_SPAN: GridCoordinates = {
  col: 1,
  row: MIN_TILE_HEIGHT_IN_CELLS,
};

export const TileSkeleton = ({ ref, onClick, span = DEFAULT_SPAN }: TileSkeletonProps) => {
  const { x: width, y: height } = gridToPx(span);
  return (
    <div ref={ref} data-e2e="tile-skeleton" className="tile-skeleton" style={{ width, height }} onClick={onClick}>
      <div className="tile-skeleton-background" />
    </div>
  );
};
